import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { removeLoadingKey } from '../helpers/common'

export const MinimumOrderQuantitiesLoadingKeys = {
  getMOQ: 'GET_MINIMUM_ORDER_QUANTITIES',
  createMOQ: 'CREATE_MINIMUM_ORDER_QUANTITIES',
  deleteMOQ: 'DELETE_MINIMUM_ORDER_QUANTITIES',
};

export const getMinimumOrderQuantitiesById = createAsyncThunk(
  'moq/getMinimumOrderQuantitiesById',
  async ({ id, type, groupId }, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/api/v1/minimum-order-quantities`, {
        params: {
          id, 
          type,
          groupId
        }
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to get moq');
    }
  }
);

export const createMinimumOrderQuantities = createAsyncThunk(
  'moq/createMinimumOrderQuantities',
  async ({ creationData }, { rejectWithValue, dispatch }) => {
    try {
        const { id, type, groupId, newMoq } = creationData
        const { data } = await axios.post('/api/v1/minimum-order-quantities', { newMoq, type });
        dispatch(getMinimumOrderQuantitiesById({ id, type, groupId }));
        return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to create moq');
    }
  }
);

export const deleteMinimumOrderQuantities = createAsyncThunk(
  'moq/deleteMinimumOrderQuantities',
  async ({ id, type, groupId, idToDelete }, { rejectWithValue, dispatch }) => {
    try {
      await axios.delete(`/api/v1/minimum-order-quantities/${idToDelete}`);
      dispatch(getMinimumOrderQuantitiesById({ id, type, groupId }));
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to delete moq');
    }
  }
);

const moqSlice = createSlice({
  name: 'moq',
  initialState: {
    items: [],
    loading: false,
    hasGroupItems: false,
    loadingKeys: [],
    error: null
  },
  reducers: {
    clearMinimumOrderQuantities: (state) => {
      state.items = [];
      state.hasGroupItems = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMinimumOrderQuantitiesById.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, MinimumOrderQuantitiesLoadingKeys.getMOQ];
      })
      .addCase(getMinimumOrderQuantitiesById.fulfilled, (state, action) => {
        state.items = action.payload?.data;
        state.hasGroupItems = action.payload?.hasGroupItems;
        state.loading = false;
        state.loadingKeys = removeLoadingKey(MinimumOrderQuantitiesLoadingKeys.getMOQ, state.loadingKeys);
      })
      .addCase(getMinimumOrderQuantitiesById.rejected, (state, action) => {
        state.error = action.error.message;
        state.items = [];
        state.loading = false;
        state.loadingKeys = removeLoadingKey(MinimumOrderQuantitiesLoadingKeys.getMOQ, state.loadingKeys);
      })
      .addCase(createMinimumOrderQuantities.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, MinimumOrderQuantitiesLoadingKeys.createMOQ];
      })
      .addCase(createMinimumOrderQuantities.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
        state.loadingKeys = removeLoadingKey(MinimumOrderQuantitiesLoadingKeys.createMOQ, state.loadingKeys);
      })
      .addCase(createMinimumOrderQuantities.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.loadingKeys = removeLoadingKey(MinimumOrderQuantitiesLoadingKeys.createMOQ, state.loadingKeys);
      })
      .addCase(deleteMinimumOrderQuantities.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, MinimumOrderQuantitiesLoadingKeys.deleteMOQ];
      })
      .addCase(deleteMinimumOrderQuantities.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.loadingKeys = removeLoadingKey(MinimumOrderQuantitiesLoadingKeys.deleteMOQ, state.loadingKeys);
      })
      .addCase(deleteMinimumOrderQuantities.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
        state.loadingKeys = removeLoadingKey(MinimumOrderQuantitiesLoadingKeys.deleteMOQ, state.loadingKeys);
      });
  }
});

export const { clearMinimumOrderQuantities } = moqSlice.actions;
export default moqSlice.reducer; 